'use client';

import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'toast group-[.toaster]:text-foreground group group-[.toaster]:border-border group-[.toaster]:bg-background group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:text-muted-foreground group-[.toast]:bg-muted',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
